module.exports = __webpack_public_path__ + "img/tdk-realsense.2d461c90.jpg";